import React, { useState } from "react";
import { CircularProgress, TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { MaterialCategoryGroup } from "../../../../data/entities";
import Edit from "../../../../shared/svg/Edit";
import DeleteIcon from "../../../../shared/svg/DeleteIcon";
import IconButton from "../../../../shared/components/IconButton";
import TextBox from "../../../../shared/components/TextBox";
import { Check } from "@mui/icons-material";
import { ConfirmModal } from "../../../ProductOrder/detail/ImportMaterial/AddImportProductModal/ConfirmModal";
import { NormalText, TitleText } from "../../../ProductOrder/detail/ImportMaterial/AddImportProductModal/ConfirmModal/Styled";
import apiMethods from "../../../../utils/api";
import { error, success } from "../../../../utils/toast";


interface PMCategoryGroupRowProps {
    item: MaterialCategoryGroup;
    extraRowProps: any;
}

const MaterialCategoryGroupRow = ({ item, extraRowProps }: PMCategoryGroupRowProps) => {
    const [editing, setEditing] = useState(false);
    const [name, setName] = useState(item.name || "");
    const [isDeleting, setIsDeleting] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);

    const handleSave = async () => {
        if (isSaving) return;
        setIsSaving(true);
        try {
            await apiMethods.patch(`/materials/category-groups/${item.id}/`, {
                name: name,
            });
            success("Sửa tên nhóm danh mục vật tư thành công", "Tên nhóm danh mục vật tư đã được cập nhật");
            setEditing(false);
            await extraRowProps.fetchItems();
        } catch (err) {
            error("Lỗi khi sửa tên nhóm danh mục vật tư", err);
        } finally {
            setIsSaving(false);
        }
    };
    
    const handleChangeName = (value: string) => {
        setName(value);
    };

    const onClickDelete = () => {
        setIsDeleting(true);
    };

    const handleDelete = async () => {
        if (isDeleteLoading) return;
        setIsDeleteLoading(true);
        try {
            await apiMethods.delete(`/materials/category-groups/${item.id}/`);
            success("Xóa nhóm danh mục vật tư thành công", "Nhóm danh mục vật tư đã được xóa khỏi hệ thống");
            await extraRowProps.fetchItems();
        } catch (err) {
            error("Lỗi khi xóa nhóm danh mục vật tư", err);
        } finally {
            setIsDeleteLoading(false);
            setIsDeleting(false);
        }
    };

    const onClickEdit = () => {
        setEditing(true);
    };

    return (
        <TableRow>
            {isDeleting && 
                <ConfirmModal
                    open={isDeleting}
                    handleClose={() => setIsDeleting(false)}
                    onClickConfirm={handleDelete as any}
                    confirmButtonText="Xóa"
                    isLoading={isDeleteLoading}
                >
                    <TitleText>Xóa nhóm danh mục vật tư</TitleText>
                    <NormalText>Bạn có chắc chắn muốn xóa nhóm danh mục vật tư này không?</NormalText>
                </ConfirmModal>
            }
            <StyledTableCell align="left">
                {item.id}
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox text={name} onChangeText={handleChangeName}  disabled={!editing}/>
            </StyledTableCell>  
            <StyledTableCell align="left">
                <IconButton style={{ marginRight: "10px" }} onClick={editing ? handleSave : onClickEdit} disabled={isSaving || isDeleteLoading}>
                    {isSaving ? <CircularProgress size={18} /> : editing ? <Check /> : <Edit />}
                </IconButton>
                <IconButton onClick={onClickDelete} disabled={isSaving || isDeleteLoading}>
                    <DeleteIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
    );
};

export default MaterialCategoryGroupRow;
